import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'scidatahub-theme';

const ThemeContext = createContext({ mode: 'light', setMode: () => {} });

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    try {
      return (localStorage.getItem(STORAGE_KEY) || 'light');
    } catch {
      return 'light';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
      document.documentElement.setAttribute('data-theme', mode);
    } catch (e) {}
  }, [mode]);

  const setMode = (next) => {
    const value = typeof next === 'function' ? next(mode) : next;
    setModeState(value === 'dark' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ mode, setMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeMode() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { mode: 'light', setMode: () => {} };
  return ctx;
}
